import React from 'react';

export default function EscarapelaIcon({ className = "w-5 h-5" }) {
  return (
    <svg viewBox="0 0 100 100" className={className} xmlns="http://www.w3.org/2000/svg">
      <g>
        {/* Base Celeste (Anillo exterior) */}
        <circle cx="50" cy="50" r="46" fill="#74ACDF" />
        
        {/* Anillo Blanco central */}
        <circle cx="50" cy="50" r="30" fill="#FFFFFF" />
        
        {/* Centro Celeste */}
        <circle cx="50" cy="50" r="14" fill="#74ACDF" />
        
        {/* Textura de pliegues/frunces (Sombras) */}
        {[...Array(36)].map((_, i) => (
          <path 
            key={`dark-${i}`} 
            d="M50 4 L50 96" 
            stroke="rgba(0,0,0,0.06)" 
            strokeWidth="1.5" 
            transform={`rotate(${i * 10} 50 50)`} 
          />
        ))}
        
        {/* Textura de pliegues/frunces (Luces) */}
        {[...Array(36)].map((_, i) => (
          <path 
            key={`light-${i}`} 
            d="M50 4 L50 96" 
            stroke="rgba(255,255,255,0.2)" 
            strokeWidth="1.5" 
            transform={`rotate(${i * 10 + 5} 50 50)`} 
          />
        ))}
      </g>
    </svg>
  );
}